import AxiosStatic from "axios";
import ExcelData from "./excel-data";

class ImportExcelService {
  $http = AxiosStatic

  async getExcelTemplate() {
    return this.$http
    .post("/api/importExcel/getExcelTemplate")
    .then(response => {
      if (response) {
        return response;
      }
      else {
        throw new Error("An unexpected error has occurred");
      }
    })
    .catch(this.formatErrorsAndRethrow)
  }

  async importExcelTemplate(template: FormData) {
    return this.$http
    .post("/api/importExcel/importExcelTemplate", template)
    .then(response => {
      if (response) {
        return response;
      }
      else {
        throw new Error("An unexpected error has occurred");
      }
    })
    .catch(this.formatErrorsAndRethrow)
  }

  async getMaxUploadFileSize() {
    return this.$http
    .get("/api/importExcel/getMaxUploadFileSize")
    .then(response => {
      if (response.data) {
        return response.data;
      }
      else {
        throw new Error("An unexpected error has occurred");
      }
    })
    .catch(this.formatErrorsAndRethrow)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private formatErrorsAndRethrow(error: any) {
    if (error.response) {
        let err = error.response.data;
        if (err.errors) {
            err = [...Object.keys(error.response.data.errors).map(
                key => error.response.data.errors[key]
            )];
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            err = err.reduce((flat: any, list: any) => flat.concat(list));
            console.log(err);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            err = err.reduce((val: any, arr: any) => `${val} \r\n${arr}`, "")
        }
        throw new Error(err);
    }
    else {
        throw new Error("An unexpected error has occurred");
    }
  }
}

export default new ImportExcelService();
